import styled from 'styled-components';
import COLORS from '../../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../../common/styles/fontStyles';
import DEVICES from '../../../../common/styles/devices';

export const RecipientInfoContainer = styled.div`
  margin-top: 48px;
  padding: 16px;
  background-color: ${COLORS.lightShadedGrey};
  width: 450px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderGrey};

  .coupon-form-container {
    width: 100%;
  }

  .transaction-info-container {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    .avatar-image {
      margin-top: 16px;
    }
    .transaction-info-sender {
      width: 100%;
      margin-left: 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-evenly;
      border-bottom: 1px solid ${COLORS.borderGrey};
    }
    .transaction-info-receiver {
      margin-top: 16px;
      margin-left: 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-evenly;
      img {
        margin-top: 16px;
      }
    }
  }
  .font-24 {
    font-size: 24px;
  }
  .font-12 {
    font-size: 12px;
  }
  .font-14 {
    font-size: 14px;
  }
  .font-700 {
    font-weight: 700;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .font-brand-blue {
    color: ${COLORS.textLinkBlue};
  }
  .font-text-grey {
    color: ${COLORS.textLightGrey};
  }
  .font-black {
    color: ${COLORS.black};
  }
  .pointer-cursor {
    cursor: pointer;
  }
  .line-height-16 {
    line-height: 16px;
  }
  .line-height-38 {
    line-height: 38px;
  }
  .line-height-26 {
    line-height: 26px;
  }
  .line-height-18 {
    line-height: 18px;
  }
  .pb-16 {
    padding-bottom: 16px;
  }

  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const CouponContainer = styled.div`
  width: 450px;
  padding: 16px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(117, 46, 255, 0.1);
  border-radius: 2px;
  .coupon-info-text-container {
    display: flex;
    flex-direction: column;
  }
  .font-bold {
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .font-24 {
    font-size: 24px;
  }
  .font-12 {
    font-size: 12px;
  }
  .font-14 {
    font-size: 14px;
  }
  .font-700 {
    font-weight: 700;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .font-brand-blue {
    color: ${COLORS.textLinkBlue};
  }
  .font-text-grey {
    color: ${COLORS.textLightGrey};
  }
  .font-black {
    color: ${COLORS.black};
  }
  .pointer-cursor {
    cursor: pointer;
  }
  .line-height-16 {
    line-height: 16px;
  }
  .line-height-38 {
    line-height: 38px;
  }
  .line-height-26 {
    line-height: 26px;
  }
  .line-height-18 {
    line-height: 18px;
  }
  .pb-16 {
    padding-bottom: 16px;
  }
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const ConfirmationTextContainer = styled.div`
  margin-top: 48px;
  width: 450px;
  font-size: 14px;
  gap: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  p {
    font-size: 14px;
    line-height: 18px;
    margin: 0;
  }
  .bold-text {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-weight: 700;
  }
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 48px;
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;
export const PaymentDetailsContainerDiv = styled.div`
  margin-top: 48px;
  width: 450px;
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;

export const DiscountBannerContainer = styled.div`
  margin-top: 48px;
  display: flex;
  width: 450px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  top: 11px;
  right: 4px;
  z-index: 999;
  .triangle {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 4px 4px 0;
    border-color: transparent ${COLORS.backgroudDarkPurple} transparent transparent;
    transform: rotate(0deg);
  }

  .discount-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0 2px 2px 0;
    background-color: ${COLORS.brandPurple};
    padding: 2px 4px;
    font-size: 10px;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-weight: 700;
    color: ${COLORS.white};
  }
  @media ${DEVICES.mobileXL} {
    width: 90% !important;
    margin-left: 20px;
    margin-right: 20px;
  }
`;
